import React from 'react';
import PropTypes from 'prop-types';

const ThinStar = ({color = 'currentColor', width = 16, height = 16, ...props}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M14 0C14 0 16.5 9.5 14 14C11.5 9.5 14 0 14 0Z" fill={color} />
    <path d="M14 28C14 28 16.5 18.5 14 14C11.5 18.5 14 28 14 28Z" fill={color} />
    <path d="M0 14C0 14 9.5 11.5 14 14C9.5 16.5 0 14 0 14Z" fill={color} />
    <path d="M28 14C28 14 18.5 11.5 14 14C18.5 16.5 28 14 28 14Z" fill={color} />
  </svg>
);

ThinStar.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ThinStar;
